import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { PRIMARY } from "../../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    //div geral
    padding: 0,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    // border: 'solid 1px blue'
  },
  actions: {
    // botão das ações
    padding: "8px 24px 24px 0",
    display: "flex",
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  content: {
    // div da tabela
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    // border: 'solid 1px red'
  },
  button: {
    width: "183px",
    color: "white",
    background: PRIMARY,
    padding: "8px 16px !important",
    // gap: "10px",
    lineHeight: "22px",
    letterSpacing: 0,
    fontSize: "14px !important",
    "&:hover": {
      background: PRIMARY,
      opacity: 0.9,
    },
  },
}));
